import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { TurnoModel } from '@/features/list-turno/types';

type Params = {
  serie_nome?: string;
  turma_sigla?: string;
}

async function getTurno(serieNome: string | number, turmaSigla?: string): Promise<TurnoModel[]> {
  const api = await getApi();
  const params = {} as Params;
  if (serieNome) {
    params.serie_nome = String(serieNome)
  }

  if (turmaSigla) {
    params.turma_sigla = turmaSigla
  }

  const { data } = await api.get('/escola/turnos/', {params});
  return data;
}

type QueryFnType = typeof getTurno;

function useTurnos(serieNome: string | number, turmaSigla?: string) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-turnos', serieNome, turmaSigla],
    queryFn: () => getTurno(serieNome, turmaSigla),
  });
}

export { getTurno, useTurnos };
